/**
 * Dialogo di avvio del monitoraggio: chiede entro quanti giorni ci si aspetta
 * la risposta, precompilato a 7 (il termine tipico assegnato in una PEC).
 *
 * Il conteggio decorre dalla DATA DI INVIO del messaggio, non da adesso: se la
 * mail e' partita ieri, con 7 giorni la scadenza cade fra sei.
 */

import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
} from '@floraltech/ui';
import type { EmailMessaggioItem } from '../lib/api';

const GIORNI_DEFAULT = 7;
const GIORNI_MIN = 1;
const GIORNI_MAX = 365;

interface Props {
  messaggio: EmailMessaggioItem;
  onConferma: (giorni: number) => void;
  onAnnulla: () => void;
}

export function MonitoraggioDialog({ messaggio, onConferma, onAnnulla }: Props) {
  const [giorni, setGiorni] = useState<string>(String(GIORNI_DEFAULT));

  // Riapri il dialogo su un altro messaggio = riparti dal default.
  useEffect(() => setGiorni(String(GIORNI_DEFAULT)), [messaggio.id]);

  const valore = Number(giorni);
  const valido = Number.isInteger(valore) && valore >= GIORNI_MIN && valore <= GIORNI_MAX;

  return (
    <Dialog open onOpenChange={(aperto) => !aperto && onAnnulla()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Monitora la risposta</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Ti avviso se <span className="font-medium">{messaggio.oggetto || '(senza oggetto)'}</span>{' '}
            resta senza risposta oltre il termine.
          </p>
          <div className="space-y-1.5">
            <Label htmlFor="giorni-monitoraggio">Giorni dalla data di invio</Label>
            <Input
              id="giorni-monitoraggio"
              type="number"
              min={GIORNI_MIN}
              max={GIORNI_MAX}
              value={giorni}
              autoFocus
              onChange={(e) => setGiorni(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && valido) onConferma(valore);
              }}
            />
            {!valido && (
              <p className="text-xs text-destructive">
                Indica un numero di giorni fra {GIORNI_MIN} e {GIORNI_MAX}.
              </p>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onAnnulla}>
            Annulla
          </Button>
          <Button disabled={!valido} onClick={() => onConferma(valore)}>
            Monitora
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
